import React from "react";

const BAR_HEIGHTS = [
  18, 24, 14, 28, 20, 30, 16, 26, 18, 22, 15, 28,
  19, 24, 17, 29, 21, 26, 14, 25, 19, 30, 18, 22,
  16, 28, 20, 25, 17, 27, 19, 23, 15, 29, 18, 26,
  18, 24, 14, 28, 20, 30, 16, 26, 18, 22, 15, 28,
  16, 28, 20, 25, 17, 27, 19, 23, 15, 29, 18, 26,
  18, 24, 14, 28, 20, 30, 16, 26, 18, 22, 15, 28,
  20, 24, 17, 28, 18, 23, 16, 27, 20, 25, 18, 30,
];

const AssetDetailChartSkeleton = () => {
  return (
    <div className="w-full">
      <div className="relative h-[215px] w-full overflow-hidden rounded-[8px] bg-background-surface p-2 sm:border sm:border-divider">

        <div className="absolute inset-0 animate-pulse">

          {/* Grid */}
          <div className="absolute left-3 right-12 top-6 h-px bg-divider" />
          <div className="absolute left-3 right-12 top-1/2 h-px bg-divider" />
          <div className="absolute bottom-7 left-3 right-12 h-px bg-divider/40" />

          {/* Fake Area Chart */}
          <svg
            className="absolute inset-x-3 top-4 bottom-8 h-[160px] w-[calc(100%-60px)]"
            viewBox="0 0 600 160"
            preserveAspectRatio="none"
          >
            <defs>
              <linearGradient
                id="chartSkeletonGradient"
                x1="0"
                y1="0"
                x2="0"
                y2="1"
              >
                <stop offset="0%" stopColor="currentColor" stopOpacity=".12" />
                <stop offset="100%" stopColor="currentColor" stopOpacity="0" />
              </linearGradient>
            </defs>

            {/* Area */}
            <path
              d="
                M0 35
                C30 10 60 45 90 25
                S150 80 180 65
                S240 60 270 55
                S330 20 360 35
                S420 120 450 100
                S510 55 540 70
                S580 40 600 55
                L600 160
                L0 160
                Z
              "
              fill="url(#chartSkeletonGradient)"
              className="text-slate-300 dark:text-zinc-700"
            />

            {/* Line */}
            <path
              d="
                M0 35
                C30 10 60 45 90 25
                S150 80 180 65
                S240 60 270 55
                S330 20 360 35
                S420 120 450 100
                S510 55 540 70
                S580 40 600 55
              "
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              className="text-slate-300 dark:text-zinc-700"
              strokeLinecap="round"
            />
          </svg>

          {/* Volume Bars */}
          <div className="absolute bottom-7 left-3 right-12 flex h-12 items-end gap-[2px]">
            {BAR_HEIGHTS.map((height, i) => (
              <div
                key={i}
                style={{ height }}
                className="flex-1 rounded-t bg-slate-300 dark:bg-zinc-700"
              />
            ))}
          </div>

          {/* Right Axis */}
          <div className="absolute right-2 top-4 bottom-8 flex flex-col justify-between">
            {Array.from({ length: 5 }).map((_, i) => (
              <div
                key={i}
                className="h-2.5 w-9 rounded-full bg-slate-200 dark:bg-zinc-700"
              />
            ))}
          </div>

          {/* Bottom Axis */}
          <div className="absolute bottom-1 left-3 right-12 flex justify-between">
            {Array.from({ length: 6 }).map((_, i) => (
              <div
                key={i}
                className="h-2.5 w-7 rounded-full bg-slate-200 dark:bg-zinc-700"
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssetDetailChartSkeleton;